import React from 'react'
import clsx from 'clsx';
import { ErrorMessage, FormikProps } from 'formik'
import { Attributes, Label, Validation } from 'app/modules/tp/builders/FormBuilder';
import { traverseKeyObj } from 'app/utils/keys';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import WysiswygAreaInput from './WysiwygAreaInput';
import { Actions } from 'app/modules/tp/components/Modal/ModalEntity';

export type WysiswygAreaInputObj<T> = {
    type: "wysiwyg",
    key: keyof T,
    placeholder?: string,
    isRequired?: boolean,
    attributes?: Attributes
    toolbar?: any,
} & Attributes & Validation & Label


export type AreaInputFieldProps<T> = {
    formik: FormikProps<T>,
    inputObj: WysiswygAreaInputObj<T>
    actions: Actions<T>,
    onChange?: (e: T) => void,
}

export const WysiswygAreaInputField = <T,>({ formik, inputObj, onChange }: AreaInputFieldProps<T>) => {

    const isRequiredField = (inputObj: WysiswygAreaInputObj<T>) => {
        return inputObj.validation?.spec?.presence === 'required'
    }
    const value = React.useMemo( () => (formik.getFieldMeta(inputObj.key as string).value as string || "")
        , [formik.values, inputObj.key]);

    return (<>
        {inputObj.label && (
            <label className={`fw-bold fs-6 mb-2 ${isRequiredField(inputObj) ? "required" : ""} `}>
                {inputObj.label}
            </label>
        )}


        <WysiswygAreaInput
            toolbar={inputObj.toolbar}
            setFieldValue={(value) => formik.setFieldValue(inputObj.key as string, value)}
            value={value}
            {...inputObj.attributes}
        />

        {formik?.touched[inputObj.key] && formik.errors[inputObj.key] && (
            <ErrorMessage name={inputObj.key as string}
                render={(error: string) => (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{error}</span>
                        </div>
                    </div>
                )} />
        )}

    </>
    )
}

export default WysiswygAreaInputField;
